import React from 'react';

import './empty-state-page.scss';

export enum EmptyStatePageIcon {
  NoNews = 'img-no-news',
  NoVideos = 'img-no-videos',
  NoDocuments = 'img-no-documents'
}

export const EmptyStatePage = (props: { text: string; icon: EmptyStatePageIcon }) => {
  return (
    <div className='empty-state-page'>
      <div className={'empty-state-img ' + props.icon} />
      {props.text}
    </div>
  );
};
